export const IMAGE_LOGO = {
    en: require('./logo/rota_uk-transparent.png'),
    el: require('./logo/rota_gr-transparent.png')
}
export const DEMO_EXPO = require('./demoExpo.jpg')